import type {
  ConversationGetApiData,
  ConversationGetApiResponses,
  ConversationListApiData,
  ConversationListApiResponses,
  ConversationMessageCreateApiData,
  ConversationMessageCreateApiResponses,
  ConversationMessageListApiData,
  ConversationMessageListApiResponses,
  ConversationPatchApiData,
  ConversationPatchApiResponses,
  ConversationTicketCreateApiData,
  ConversationTicketCreateApiResponses,
  ConversationTicketListApiData,
  ConversationTicketListApiResponses,
  CustomerSupportTimelineListApiData,
  CustomerSupportTimelineListApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export { conversationIdFromSseData } from './sseParse';
export type { SupportInboxSseEvent } from './sseParse';

export const getSupportConversationUrls = {
  getPaginatedSupportConversations: dataEndpoint<ConversationListApiData, ConversationListApiResponses>({
    getUrl: (queryParams) => apiUrl('conversations/', queryParams)
  }),
  getSupportConversation: dataEndpoint<ConversationGetApiData, ConversationGetApiResponses>({
    getUrl: ({ conversationId }) => apiUrl(`conversations/${conversationId}/`)
  }),
  getPaginatedSupportConversationMessages: dataEndpoint<
    ConversationMessageListApiData,
    ConversationMessageListApiResponses
  >({
    getUrl: ({ conversationId, ...queryParams }) => apiUrl(`conversations/${conversationId}/messages/`, queryParams)
  }),
  getPaginatedSupportConversationTickets: dataEndpoint<
    ConversationTicketListApiData,
    ConversationTicketListApiResponses
  >({
    getUrl: ({ conversationId, ...queryParams }) => apiUrl(`conversations/${conversationId}/tickets/`, queryParams)
  }),
  postSupportConversationReply: responseEndpoint<
    ConversationMessageCreateApiData,
    ConversationMessageCreateApiResponses
  >({
    getUrl: ({ conversationId }) => apiUrl(`conversations/${conversationId}/messages/`),
    getBody: ({ conversationId: _, ...body }) => body
  }),
  patchSupportConversation: responseEndpoint<ConversationPatchApiData, ConversationPatchApiResponses>({
    getUrl: ({ conversationId }) => apiUrl(`conversations/${conversationId}/`),
    getBody: ({ conversationId: _, ...body }) => body
  }),
  postSupportConversationTicket: responseEndpoint<
    ConversationTicketCreateApiData,
    ConversationTicketCreateApiResponses
  >({
    getUrl: ({ conversationId }) => apiUrl(`conversations/${conversationId}/tickets/`),
    getBody: ({ conversationId: _, ...body }) => body
  }),
  /** B6: channel-bound message feed for a user-group profile (no conversation collapse). */
  getPaginatedUserGroupSupportTimeline: dataEndpoint<
    CustomerSupportTimelineListApiData,
    CustomerSupportTimelineListApiResponses
  >({
    getUrl: ({ userGroupId, ...queryParams }) => apiUrl(`user-groups/${userGroupId}/support-timeline/`, queryParams)
  })
};
